import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Badge from '@mui/material/Badge';
import NameReservation from './nameReservation';
import NameReservationRetry from './nameReservationRetry';
import { useLocation, useParams } from 'react-router-dom';
import './styles.css';
import Incorporation from './incorporation';
import Partnership from './partnership';
import LLP from './llp';

import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router';
import axios from 'axios';
import { CommonConfig } from '../../config/common-config';
const useStyles = makeStyles((theme) => ({
    root: {
        margin: '0',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightMedium,
        color: '#4c4c4d',
        fontFamily: 'Rubik',
    },
    checked: {},
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    accordContentSummary: {
        background: '#f9f9f9',
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
        right: '72px',
        position: 'absolute',
        top: '18px',
    },
    marginTop: {
        marginTop: '9px !important',
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightMedium,
        color: '#4c4c4d',
        fontFamily: 'Rubik',
        ['@media (max-width:600px)']: {
            marginTop: '-15px !important',
        },
    },
}));
// function StyledRadio(props) {
//     const classes = useStyles();

//     return (
//         <Radio
//             className={classes.root}
//             disableRipple
//             color="default"
//             checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
//             icon={<span className={classes.icon} />}
//             {...props}
//         />
//     );
// }
export default function Accordin(props, values) {
    const classes = useStyles();
    const location = useLocation();
    const { id } = useParams();

    // const [selectedValue, setSelectedValue] = React.useState('a');

    const [generalInformation, setGeneralInformationData] = useState([]);

    //console.log('generalInformation', generalInformation);
    const [expanded, setExpanded] = React.useState('');
    const history = useHistory();
    const [incorporationValues, setIncorporationValues] = React.useState({
        id: '',
        company_type: '',
        is_subsidiary: '',
        company_overview: '',
        company_name_one: '',
        activity_name_one: '',
        company_name_two: '',
        activity_name_two: '',
        activity_name_three: '',
        company_name_three: '',
        activity_name_four: '',
        company_name_four: '',
        status: '',
        name_rejection_file: '',
        name_registered_file: '',
        name_reservation_id: '',
        company_incorporation_details: [],
    });

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    // const handleChange = (event) => {
    //     setSelectedValue(event.target.value);
    // };

    const navigate = () => {
        //console.log();
        history.push('/menu/addAdditional');
    };

    React.useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const service_id = queryParams.get('service_id');

        axios
            .get(`${CommonConfig.dev.appUrl}/api/admin/orders/get_by_service_id/${service_id}`, {
                // headers: {
                //     Authorization:
                //         'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjo0OSwiZW1haWwiOiJhcnVuQG1pbmRzdGFjay5pbiIsImZpcnN0X25hbWUiOiJzaGF6YWQiLCJsYXN0X25hbWUiOiJtYXZlZCJ9LCJpYXQiOjE2ODYyMDEzNzAsImV4cCI6MTY4NjI4Nzc3MH0.A31TvWf6Jq-dP7DWdb5BW6tbhzHEG_BBh5tTTYeE8fE',
                // },
            })
            .then((response) => {
                setIncorporationValues({
                    id: response.data.data.id,
                    company_type: response.data.data.company_type,
                    company_overview: response.data.data.business_overview,
                    company_name_one: response.data.data.name_reservations?.[0]?.unique_word_1_attempt_one,
                    activity_name_one: response.data.data.name_reservations?.[0]?.activity_word_1_attempt_one,
                    company_name_two: response.data.data.name_reservations?.[0]?.unique_word_2_attempt_one,
                    activity_name_two: response.data.data.name_reservations?.[0]?.activity_word_2_attempt_one,
                    company_name_three: response.data.data.name_reservations?.[0]?.unique_word_3_attempt_two,
                    activity_name_three: response.data.data.name_reservations?.[0]?.activity_word_3_attempt_two,
                    company_name_four: response.data.data.name_reservations?.[0]?.unique_word_4_attempt_two,
                    activity_name_four: response.data.data.name_reservations?.[0]?.activity_word_4_attempt_two,
                    is_subsidiary: response.data.data.is_subsidiary_incorporated_outside,
                    status: response.data.data.status,
                    reserved_on: response.data.data.name_reservations?.[0]?.reserved_on,
                    // name_reservation_id: response.data.data.name_reservations?.[0]?.id,
                    name_reservations: response.data.data.name_reservations,
                    company_incorporation_details: response.data.data.company_incorporation_details,
                });
            })
            .catch(() => {});
    }, []);

    const isIncorporationDisabled = () => {
        if (
            incorporationValues?.name_reservations?.[0]?.status == 'Name 1 Accepted' ||
            incorporationValues?.name_reservations?.[0]?.status == 'Name 2 Accepted' ||
            incorporationValues?.name_reservations?.[0]?.status == 'Name 3 Accepted' ||
            incorporationValues?.name_reservations?.[0]?.status == 'Name 4 Accepted'
        ) {
            return false;
        } else {
            return true;
        }
    };

    const isNameRetryDisabled = () => {
        if (
            incorporationValues?.name_reservations?.[0]?.status == 'Name 2 Rejected' ||
            incorporationValues?.name_reservations?.[0]?.status == 'Name 3 and 4 created'
        ) {
            return false;
        } else if (
            incorporationValues?.name_reservations?.[0]?.status == 'Name 3 Accepted' ||
            incorporationValues?.name_reservations?.[0]?.status == 'Name 4 Accepted' ||
            incorporationValues?.name_reservations?.[0]?.status == 'Name 4 Rejected'
        ) {
            return false;
        } else {
            return true;
        }
    };

    const completedBageName = (type) => {
        if (type == 'name_reservation') {
            if (
                incorporationValues?.name_reservations?.[0]?.status == 'Name 1 Accepted' ||
                incorporationValues?.name_reservations?.[0]?.status == 'Name 2 Accepted' ||
                incorporationValues?.name_reservations?.[0]?.status == 'Name 2 Rejected' ||
                incorporationValues?.name_reservations?.[0]?.status == 'Name 3 Accepted' ||
                incorporationValues?.name_reservations?.[0]?.status == 'Name 4 Accepted' ||
                incorporationValues?.name_reservations?.[0]?.status == 'Name 3 and 4 created'
            ) {
                return (
                    <Badge
                        badgeContent="Completed"
                        color="success"
                        style={{ marginRight: '30px', marginLeft: 'auto', marginTop: '13px' }}
                    ></Badge>
                );
            }
        } else {
            if (
                incorporationValues?.name_reservations?.[0]?.status == 'Name 3 Accepted' ||
                incorporationValues?.name_reservations?.[0]?.status == 'Name 4 Accepted'
            ) {
                return (
                    <Badge
                        badgeContent="Completed"
                        color="success"
                        style={{ marginRight: '30px', marginLeft: 'auto', marginTop: '13px' }}
                    ></Badge>
                );
            }
        }
    };
    return (
        <div className={classes.root}>
            {incorporationValues.company_type === 'Private Company' ||
            incorporationValues.company_type === 'Public Company' ||
            incorporationValues.company_type === 'One Person Company' ||
            incorporationValues.company_type === 'private_company' ||
            incorporationValues.company_type === 'public_company' ||
            incorporationValues.company_type === 'one_person_company' ? (
                <>
                    <Accordion square expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1a-header" className="padding10">
                            <Typography className={classes.heading}>Name Reservation</Typography>
                            {completedBageName('name_reservation')}
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordContentSummary}>
                            <NameReservation NameReservationData={incorporationValues} />
                        </AccordionDetails>
                    </Accordion>
                    <Accordion square expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            id="panel1a-header"
                            className="padding10"
                            disabled={isNameRetryDisabled()}
                        >
                            <Typography className={classes.heading}>Name Reservation Retry</Typography>
                            {completedBageName('name_reservation_retry')}
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordContentSummary}>
                            <NameReservationRetry NameReservationData={incorporationValues} />
                        </AccordionDetails>
                    </Accordion>
                    <Accordion square expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                            className="padding10"
                            disabled={isIncorporationDisabled()}
                        >
                            <Typography className={classes.heading}>Company Incorporation</Typography>
                            {incorporationValues?.company_incorporation_details?.[0]?.status == 'Company Incorporated' ||
                            incorporationValues?.company_incorporation_details?.[0]?.status == 'Application Rejected' ? (
                                <Badge
                                    badgeContent="Completed"
                                    color="success"
                                    style={{ marginRight: '30px', marginLeft: 'auto', marginTop: '13px' }}
                                ></Badge>
                            ) : null}
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordContentSummary}>
                            <Incorporation IncorporationData={incorporationValues} />
                        </AccordionDetails>
                    </Accordion>
                </>
            ) : incorporationValues.company_type === 'LLP' ? (
                <>
                    <Accordion square expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1a-header" className="padding10">
                            <Typography className={classes.heading}>Name Reservation</Typography>
                            {completedBageName('name_reservation')}
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordContentSummary}>
                            <NameReservation NameReservationData={incorporationValues} />
                        </AccordionDetails>
                    </Accordion>
                    <Accordion square expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            id="panel1a-header"
                            className="padding10"
                            disabled={isNameRetryDisabled()}
                        >
                            <Typography className={classes.heading}>Name Reservation Retry</Typography>
                            {completedBageName('name_reservation_retry')}
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordContentSummary}>
                            <NameReservationRetry NameReservationData={incorporationValues} />
                        </AccordionDetails>
                    </Accordion>
                    <Accordion square expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel4a-content"
                            id="panel4a-header"
                            className="padding10"
                            disabled={isIncorporationDisabled()}
                        >
                            <Typography className={classes.heading}>LLP</Typography>
                            {incorporationValues?.company_incorporation_details?.[0]?.status == 'Company Incorporated' ||
                            incorporationValues?.company_incorporation_details?.[0]?.status == 'Application Rejected' ? (
                                <Badge
                                    badgeContent="Completed"
                                    color="success"
                                    style={{ marginRight: '30px', marginLeft: 'auto', marginTop: '13px' }}
                                ></Badge>
                            ) : null}
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordContentSummary}>
                            <LLP IncorporationData={incorporationValues} />
                        </AccordionDetails>
                    </Accordion>
                </>
            ) : incorporationValues.company_type === 'Partnership' ? (
                <>
                    <Accordion square expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel3a-content"
                            id="panel3a-header"
                            className="padding10"
                        >
                            <Typography className={classes.heading}>Partnership</Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordContentSummary}>
                            <Partnership IncorporationData={incorporationValues} />
                        </AccordionDetails>
                    </Accordion>
                </>
            ) : (
                ''
            )}
        </div>
    );
}
